const damBackendTypes = {
    UAM: 'UAM',
    UAMF: 'UAMF',
};

export default damBackendTypes;
